import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.
import { Label } from "radix-ui";
import { useId } from "react";
import { cn } from "../cn.js";
/** Labeled single-line text input with optional help text and error. */
export function TextField({ label, description, error, id, className, ref, ...props }) {
    const generated = useId();
    const inputId = id ?? generated;
    const descriptionId = description ? inputId + "-description" : undefined;
    const errorId = error ? inputId + "-error" : undefined;
    const describedBy = [descriptionId, errorId].filter(Boolean).join(" ") || undefined;
    return (_jsxs("div", { className: cn("flex flex-col gap-1.5", className), children: [_jsx(Label.Root, { htmlFor: inputId, className: "text-[13px] font-medium text-fg", children: label }), _jsx("input", { ref: ref, id: inputId, "aria-invalid": error ? true : undefined, "aria-describedby": describedBy, className: "g-input", ...props }), description && (_jsx("p", { id: descriptionId, className: "text-xs text-fg-muted", children: description })), error && (_jsx("p", { id: errorId, className: "text-xs text-danger", children: error }))] }));
}
//# sourceMappingURL=TextField.js.map